import addAbsenceEventUrl from './addAbsenceEvent.html';

export default {
  templateUrl: addAbsenceEventUrl,
  controllerAs: 'ctrl',
  bindings: {
    data: '=',
    modal: '=',
    type: '@',
  },
};
